import styled from "styled-components";
import { units } from "@m/alchemy-theme";
import { Link } from "../link/Link";
export const ToolbarLink = styled(Link) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  display: inline-block;
  align-items: center;
  padding: 0 ${units(1)};
`;
